import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { scrollElementToPosition } from '../../utils/scroll-helpers'
import { useHorizontalScrollMenu } from './useHorizontalScrollMenu'

import './HorizontalScrollMenu.css'

const HorizontalScrollMenu = ({
  leftArrowButton,
  rightArrowButton,
  handleScroll,
  children,
  activeItemId,
  scrollDistanceMultiplier
}) => {
  const RightArrowButton = rightArrowButton
  const LeftArrowButton = leftArrowButton
  const {
    itemContainerRef,
    handleLeftArrowClick,
    handleRightArrowClick,
    hideLeftArrow,
    hideRightArrow
  } = useHorizontalScrollMenu(activeItemId, handleScroll, scrollDistanceMultiplier)

  return (
    <div styleName='root'>
      <LeftArrowButton
        styleName={cx('arrow left', { hide: hideLeftArrow })}
        onClick={handleLeftArrowClick}
        data-testid='arrow-left'
      />
      <div styleName='itemContainer' ref={itemContainerRef} data-testid='itemContainer'>
        {children}
      </div>
      <RightArrowButton
        styleName={cx('arrow right', { hide: hideRightArrow })}
        onClick={handleRightArrowClick}
        data-testid='arrow-right'
      />
    </div>
  )
}

HorizontalScrollMenu.propTypes = {
  leftArrowButton: PropTypes.any,
  rightArrowButton: PropTypes.any,
  handleScroll: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  activeItemId: PropTypes.string,
  scrollDistanceMultiplier: PropTypes.number
}

HorizontalScrollMenu.defaultProps = {
  // scrollElementToPosition is an abstraction of the browser scrollTo api
  handleScroll: scrollElementToPosition,
  // on arrow click, scroll 75% of the visible scrollbar distance
  scrollDistanceMultiplier: 0.75
}

export { HorizontalScrollMenu }
